import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';

import toast from 'components/partials/toast/toast';

import { deleteConversation } from 'api/ai-assistant/ai-assistant-api';

import { AI_ASSISTANT_CONVERSATIONS_KEY } from '../ai-assistant.constants';

interface UseApiDeleteConversationArgs {
  oktaUserId: string;
  clientId: string | number;
}

interface ApiErrorLike {
  data?: { detail?: string };
}

export const useApiDeleteConversation = ({
  oktaUserId,
  clientId,
}: UseApiDeleteConversationArgs): UseMutationResult<
  unknown,
  ApiErrorLike,
  string
> => {
  const queryClient = useQueryClient();

  return useMutation<unknown, ApiErrorLike, string>({
    mutationFn: (conversationId) =>
      deleteConversation({ oktaUserId, conversationId, clientId }),
    onSuccess: () => {
      toast.success({
        title: 'Conversation deleted',
        message: 'The conversation has been successfully deleted.',
      });
      queryClient.invalidateQueries({
        queryKey: [AI_ASSISTANT_CONVERSATIONS_KEY, oktaUserId, clientId],
      });
    },
    onError: (error) =>
      toast.error({
        title: 'Error deleting conversation',
        message: error?.data?.detail,
      }),
  });
};
